var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-list"},[(_vm.isVerticalScreen())?_c('v'):_c('h')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }